import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchdeleteethicsCounsellor } from "./helpAndAssistantApi";
import swal from 'sweetalert';
export interface deleteethicsCounsellorState {
  deleteethicsCounsellor: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: deleteethicsCounsellorState = {
  deleteethicsCounsellor: [],
  status: "idle",
};

export const GetdeleteethicsCounsellor = createAsyncThunk(
  "deleteethicsCounsellor",
  async (data: any) => {
    const response = await fetchdeleteethicsCounsellor(data);
    return response;
  }
);

export const DeleteethicsCounsellorSlice = createSlice({
  name: "deleteethicsCounsellor",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetdeleteethicsCounsellor.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetdeleteethicsCounsellor.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetdeleteethicsCounsellor.fulfilled, (state, action) => {
        state.status = "success";
        state.deleteethicsCounsellor = action.payload;
        //swal("Record saved success!",  "success");
      });
  },
});

export const {} = DeleteethicsCounsellorSlice.actions;

export const selectdeleteethicsCounsellor = (state: RootState) => {
  return state.DeleteethicsCounsellor.deleteethicsCounsellor;
};

export default DeleteethicsCounsellorSlice.reducer;
